import { GIF_SETTING_LIMITS, MIN_GIF_IMAGES } from "./gifConstants";

export const validateGifSettings = ({ images, settings }) => {
  if (!Array.isArray(images) || images.length < MIN_GIF_IMAGES) {
    return `Please upload at least ${MIN_GIF_IMAGES} images to generate a GIF.`;
  }

  const { width, height, frameDelay, loopCount, crossfade, crossfadeSteps, background } =
    settings || {};
  const limits = GIF_SETTING_LIMITS;

  if (!Number.isFinite(width) || width < limits.width.min || width > limits.width.max) {
    return `GIF width must be between ${limits.width.min} and ${limits.width.max} pixels.`;
  }

  if (!Number.isFinite(height) || height < limits.height.min || height > limits.height.max) {
    return `GIF height must be between ${limits.height.min} and ${limits.height.max} pixels.`;
  }

  if (
    !Number.isFinite(frameDelay) ||
    frameDelay < limits.frameDelay.min ||
    frameDelay > limits.frameDelay.max
  ) {
    return `Frame delay must be between ${limits.frameDelay.min} and ${limits.frameDelay.max} milliseconds.`;
  }

  if (
    !Number.isFinite(loopCount) ||
    loopCount < limits.loopCount.min ||
    loopCount > limits.loopCount.max
  ) {
    return `Number of loops must be between ${limits.loopCount.min} and ${limits.loopCount.max}. Use 0 for continuous looping.`;
  }

  if (crossfade) {
    if (
      !Number.isFinite(crossfadeSteps) ||
      crossfadeSteps < limits.crossfadeSteps.min ||
      crossfadeSteps > limits.crossfadeSteps.max
    ) {
      return `Crossfade steps must be between ${limits.crossfadeSteps.min} and ${limits.crossfadeSteps.max}.`;
    }
  }

  if (background && !/^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(background)) {
    return "Background must be a valid hex colour (for example #ffffff).";
  }

  return null;
};
